import { gql } from '@urql/core';

export const ALL_USERS_QUERY = gql`
    query GetAllUsers($page: Int, $perPage: Int, $usersFullName: String) {
        users(page: $page, perPage: $perPage, fullName: $usersFullName) {
            totalCount
            nodes {
                id
                createdAt
                email
                fullName
                isAdmin
                isOnboarded
                organization {
                    id
                    name
                }
            }
        }
    }
`;

export const USERS_LIST_QUERY = gql`
    query GetUsersList(
        $page: Int
        $perPage: Int
        $sort: UserSort
        $fullName: String
        $organizationId: ID
    ) {
        users(
            page: $page
            perPage: $perPage
            sort: $sort
            fullName: $fullName
            organizationId: $organizationId
        ) {
            totalCount
            nodes {
                id
                email
                fullName
                organization {
                    id
                    name
                }
                isAdmin
            }
        }
    }
`;

export const GET_USER_QUERY = gql`
    query GetUser {
        authUser {
            id
            createdAt
            email
            fullName
            isAdmin
            isOnboarded
            organization {
                id
                name
            }
        }
    }
`;

export const GET_USER_STRUCTURES_QUERY = gql`
    query GetUserStructures($id: ID!, $page: Int, $perPage: Int, $editorPrivilege: Boolean) {
        user(id: $id) {
            structures(page: $page, perPage: $perPage, editorPrivilege: $editorPrivilege) {
                nodes {
                    id
                    name
                }
                totalCount
            }
        }
    }
`;
